import {
  CACHE_TAG_DISPOSAL_TICKET_VERSION_LIST,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_WORK_ORDER_DISPOSAL_TICKET,
  CACHE_TAG_WORK_ORDER_LIST,
  CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
} from 'api/cacheTagTypes'
import { withIdTag } from 'utils/cache'

import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    updateWorkOrdersDisposalTicket: builder.mutation({
      query: ({ workOrderId, body, disposalTicketId }) => ({
        url: `/api/v1/core/work-orders/${workOrderId}/disposal-tickets/${disposalTicketId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        ...withIdTag(CACHE_TAG_WORK_ORDER_LIST, arg.workOrderId),
        ...withIdTag(CACHE_TAG_WORK_ORDER_LIST_SUMMARY, arg.workOrderId),
        ...withIdTag(CACHE_TAG_DISPOSAL_TICKET_VERSION_LIST, arg.workOrderId),
        CACHE_TAG_ROUTES_STOPS,
        CACHE_TAG_WORK_ORDER_DISPOSAL_TICKET,
      ],
    }),
  }),
})

export const { useUpdateWorkOrdersDisposalTicketMutation } = extendedApi
